import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Box,
  Alert,
  CircularProgress,
  Backdrop,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { userLogout } from '../../apiCalls/functions';
import { useAuth } from '../../hooks/contexts/AuthContext';
import { userAccountDelete } from '../../apiCalls/urls/urlFunction';

export const AccountDelete = () => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  const [apiResponse, setApiResponse] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { setAuthUser, setIsLoggedIn } = useAuth();

  const handleDelete = async () => {
    if (reason.length < 10) {
      setError('Reason must be at least 10 characters long.');
      return;
    }

    setError('');
    setApiResponse({ type: '', message: '' });
    setLoading(true);

    try {
      // ✅ Call the API with reason
      const response = await userAccountDelete(reason);

      // Backend returns success boolean
      if (response.success) {
        setApiResponse({
          type: 'success',
          message: response.message || 'Your account has been deleted successfully.',
        });

        // Logout user
        userLogout();
        setAuthUser(null);
        setIsLoggedIn(false);

        navigate('/', { replace: true });
      } else {
        setApiResponse({
          type: 'error',
          message: response.message || 'Failed to delete account.',
        });
      }
    } catch (err) {
      setApiResponse({
        type: 'error',
        message: err.response?.data?.message || err.message || 'Something went wrong.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Backdrop during API call */}
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Card sx={{ mb: 3, backgroundColor: 'white.main', boxShadow: 0, p: 2 }}>
        <CardContent>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Delete Account
          </Typography>

          {apiResponse.message && (
            <Alert severity={apiResponse.type} sx={{ mb: 2 }}>
              {apiResponse.message}
            </Alert>
          )}

          <TextField
            fullWidth
            multiline
            rows={3}
            label="Reason for deleting your account"
            variant="outlined"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            error={!!error}
            helperText={error}
            sx={{ mb: 2 }}
          />

          <Box textAlign="right">
            <Button
              variant="contained"
              color="error"
              disabled={reason.length < 10 || loading}
              onClick={handleDelete}
            >
              {loading ? 'Deleting...' : 'Delete Account'}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};
